import { render, staticRenderFns } from "./jcxEditList.vue?vue&type=template&id=6cd1cfdb&"
import script from "./jcxEditList.vue?vue&type=script&lang=js&"
export * from "./jcxEditList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports